import { getAbTestV2, trackAbTestV2Variant } from 'dibs-buyer-layout/exports/clientABTestV2';

export const PERSONALIZED_RERANK_TEST_NAME = 'Personalized-Rerank' as const;
export const ITEM_PRICE_IN_SELLABILITY = 'ItemPriceInSellability' as const;
export const TRADE_QUICK_FILTERS = 'TradeQuickFilters' as const;
export const URGENCY_SIGNALS_MW = 'CartUrgencySignalMWv2' as const;
export const TABLE_SIZE_FILTER = 'TableSizeFilter' as const;
export const SHIPPING_COST_SB = 'ShippingCostSB' as const;
export const CONTENT_VISIBILITY_SB = 'ContentVisibilitySB' as const;
export const SHIPS_FROM_SB_TILE = 'ShipsFromSBTile' as const;
export const SPONSORED_LISTING_ON_PDP = 'SponsoredListingsOnPDP' as const;
const PDP_ML_RERANK_YMAL_TEST = 'PDPML_ReranktopYMAL_Aug2025';
export const SPONSORED_LISTINGS_MORE_ROWS = 'SponsoredListingsMoreRows' as const;

export const getPersonalizedRerankAbTestVariant = (): string | undefined =>
    getAbTestV2(PERSONALIZED_RERANK_TEST_NAME)?.variant;

export const getShippingCostSbVariant = (): string | undefined =>
    getAbTestV2(SHIPPING_COST_SB)?.variant;

export const getIsShipsFromSBTileVariant = (getAbTestFunc = getAbTestV2): boolean =>
    getAbTestFunc(SHIPS_FROM_SB_TILE)?.variant === 'variant';

export const getPdpYmalRerankTestMlType = (
    getAbTestFunc: $TSFixMe
): 'ALL_ITEMS_RERANKED' | undefined => {
    if (typeof getAbTestFunc !== 'function') {
        return undefined;
    }

    const isRerankYmalTest = getAbTestFunc(PDP_ML_RERANK_YMAL_TEST)?.variant === 'variant';

    return isRerankYmalTest ? 'ALL_ITEMS_RERANKED' : undefined;
};

export const trackPdpYmalRerankTest = (): void => {
    trackAbTestV2Variant(PDP_ML_RERANK_YMAL_TEST);
};

export const getSponsoredListingOnPdpVariant = (): string | undefined =>
    getAbTestV2(SPONSORED_LISTING_ON_PDP)?.variant;
